import React from 'react';

import MessageConnecting from 'components/pos/MessageConnecting.component';
import MessageFailure from 'components/pos/MessageFailure.component';
import MessageOffline from 'components/pos/MessageOffline.component';
import MessageSuccess from 'components/pos/MessageSuccess.component';
import MessageWaiting from 'components/pos/MessageWaiting.component';
import PRDS from 'components/pos/PosReaderDialogStatus.const';

const MAP = Object.freeze({
  [PRDS.connected]: MessageWaiting,
  [PRDS.success]: MessageSuccess,
  [PRDS.failure]: MessageFailure,
  [PRDS.disconnected]: MessageOffline,
});

const PosStateMessage = (props) => {
  const { posStep } = props;

  // determine the proper component to use
  const Component = MAP[posStep] || MessageConnecting;

  // use it with the same props, nothing more than that
  return <Component {...props} />;
};

export default PosStateMessage;
